module.exports = __webpack_public_path__ + "img/icon03.866bbe57.png";